// extracted by mini-css-extract-plugin
module.exports = {"pageContainerForm":"createSubscription_pageContainerForm__isRYW","formHeader":"createSubscription_formHeader__1hgj0","formBody":"createSubscription_formBody__3fyi2"};